import cropr from "../../shared/utils/cropr";
import { useEffect, useState } from "react";

const getFromCloudfarm = (url: string, success: any, fail: any, sendData: any) => {
  //todo use searchkit?
  let settings = {
    url: cropr.cloudfarm_domain + url,
    type: sendData ? "POST" : "GET",
    data: sendData && JSON.stringify(sendData),
    dataType: "json",
    headers: { Authorization: "Bearer " + cropr.cloudfarm_oauth_token },
    contentType: "application/json; charset=utf-8",
    success: success,
    timeout: 3000,
    error:
      fail ||
      function (error: any) {
        console.error("getFromCloudfarmError", error);
      },
  };
  $.ajax(settings);
};

export const useCloudFarmDataSetCount = (startDateStamp: number, endDateStamp: number): number => {
  const [count, setCount] = useState<number>(0);
  const url = "/api/data/datasets/elasticsearch/_search";
  useEffect(() => {
    (cropr.features.cloudfarm || cropr.features.cloudfarm_contract) &&
      getFromCloudfarm(
        url,
        (data: any) => setCount(data.hits.total.value),
        (error: any) => console.error("error in getFromCloudfarm", error),
        {
          query: {
            bool: {
              should: [
                {
                  term: {
                    "data_set_rois.roi_grp_id.keyword": cropr.getActivePlan().get("did"),
                  },
                },
                {
                  bool: {
                    must_not: {
                      terms: {
                        "data_format.keyword": ["n"],
                      },
                    },
                  },
                },
              ],
              must: [
                {
                  range: { created: { gte: startDateStamp * 1000, lte: endDateStamp * 1000 } },
                },
              ],
            },
          },
          size: 0,
          sort: [
            {
              created: "desc",
            },
          ],
        }
      );
  }, [startDateStamp, endDateStamp]);
  return count;
};
